export default __webpack_public_path__ + "0396e87147b3917332d56d60ec49ea2c.png";